import { render, staticRenderFns } from "./UIDemandQuotedPrice.vue?vue&type=template&id=6ca0d1d6&scoped=true&"
import script from "./UIDemandQuotedPrice.vue?vue&type=script&lang=js&"
export * from "./UIDemandQuotedPrice.vue?vue&type=script&lang=js&"
import style0 from "./UIDemandQuotedPrice.vue?vue&type=style&index=0&id=6ca0d1d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca0d1d6",
  null
  
)

export default component.exports